import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useGetDeletedUsersQuery, DeletedUser } from "../../store/services/users";

const REASON_LABELS: Record<string, string> = {
  NO_LONGER_USE: "Ya no uso la app",
  PRIVACY: "No quiero compartir mis datos",
  TOO_MANY_NOTIFICATIONS: "Demasiadas notificaciones",
  BUG_OR_ERROR: "La app tiene errores",
  OTHER: "Otro motivo",
};

const formatDate = (value: string | null): string => {
  if (!value) return "—";
  try {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleString();
  } catch {
    return value;
  }
};

const reasonBody = (row: DeletedUser) => {
  if (!row.deletionReasonCode && !row.deletionReason) return "—";
  const label = row.deletionReasonCode ? REASON_LABELS[row.deletionReasonCode] ?? row.deletionReasonCode : "";
  if (row.deletionReason) {
    return label ? `${label} — ${row.deletionReason}` : row.deletionReason;
  }
  return label || "—";
};

const dateBody = (key: keyof DeletedUser) => (row: DeletedUser) =>
  formatDate((row[key] as string | null) ?? null);

export const DeletedUsers = () => {
  const { data, isLoading, isError, refetch } = useGetDeletedUsersQuery();

  return (
    <div className="card">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>Cuentas eliminadas</h2>
        <button className="p-button p-button-outlined" onClick={() => refetch()}>
          Refrescar
        </button>
      </div>

      {isError && (
        <div style={{ color: "#b91c1c", marginBottom: 12 }}>
          No se pudieron cargar las cuentas eliminadas.
        </div>
      )}

      <DataTable
        value={data ?? []}
        loading={isLoading}
        paginator
        rows={20}
        rowsPerPageOptions={[10, 20, 50, 100]}
        emptyMessage="No hay cuentas eliminadas todavía."
        responsiveLayout="scroll"
      >
        <Column field="id" header="ID" style={{ width: 80 }} />
        <Column field="preDeletionEmail" header="Email original" />
        <Column header="Motivo" body={reasonBody} />
        <Column header="Eliminada" body={dateBody("deletedAt")} />
        <Column header="Registrada" body={dateBody("createDate")} />
      </DataTable>
    </div>
  );
};

export default DeletedUsers;
